import { render, staticRenderFns } from "./SfFooter.vue?vue&type=template&id=166e5f1d&"
import script from "./SfFooter.vue?vue&type=script&lang=js&"
export * from "./SfFooter.vue?vue&type=script&lang=js&"
import style0 from "./SfFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports